// extracted by mini-css-extract-plugin
export default {"block":"BludataContainerBlock_block__Yi0Vi"};